// CUSTOMIZED: Entfernen des letzten Bundles zeigt zuverlässig die leere Warenkorbseite an
if (!window.__edmBundleRemoveInit) {
    window.__edmBundleRemoveInit = true;
  
    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-remove-bundle]');
      if (!btn) return;
  
      const row = btn.closest('tr.cart-item--bundle');
      const keys = (row?.dataset.keysAll || '').split(',').filter(Boolean);
  
      // 1) Alle Kinderzeilen löschen
      for (const k of keys) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ id: k, quantity: 0 })
        });
      }
  
      // 2) Cart-State prüfen
      const cartState = await fetch('/cart.js', {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).then(r => r.json());
  
      // 3) Wenn leer → auf /cart gehen (zeigt die Standard-Empty-Ansicht)
      if ((cartState?.item_count || 0) === 0) {
        if (window.location.pathname.indexOf('/cart') !== -1) {
          window.location.reload();
        } else {
          window.location.href = (window.routes?.cart_url || '/cart');
        }
        return;
      }
  
      // 4) Nicht leer → Drawer/Notification sauber neu rendern
      const cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartEl?.getSectionsToRender) {
        const sections = cartEl.getSectionsToRender().map(s => s.id);
        const url = `${window.location.pathname}?sections=${sections.join(',')}`;
        const res = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        cartEl.renderContents({ sections: await res.json() });
      } else {
        // Fallback
        window.location.reload();
      }
    });
  }
  
  